<template>
  <div class="aeEventList">
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/financeCenter/aeEvent';
  // import DictSpan from '@/components/DictSpan';
  import tableMixins from '@/common/mixins/table.js';
  import { mapState } from 'vuex';
  export default {
    name: 'aeEventList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      // DictSpan,
      SiruiTable,
    },
    computed: {
      searchColumns() {
        return [
          {
            name: '业务模块代码',
            prop: 'applicationCode',
            type: 'input',
            clearable: true,
          },
          {
            name: '业务实体代码',
            prop: 'entityCode',
            type: 'input',
            clearable: true,
          },
          {
            name: '事件分类代码',
            prop: 'eventCode',
            type: 'input',
            clearable: true,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        dictList: (state) => state.dict.dictList,
      }),
    },
    data() {
      return {
        searchForm: {
          configName: null,
          configKey: null,
          configType: null,
        },
        load: false,
        tableData: [],
        multipleSelection: [],
        menuButtonList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'applicationCode',
            title: '业务模块代码',
            visible: true,
          },
          {
            field: 'entityCode',
            title: '业务实体代码',
            visible: true,
          },
          {
            field: 'eventCode',
            title: '事件分类代码',
            visible: true,
          },
          {
            field: 'eventName',
            title: '事件分类名称',
            visible: true,
          },
          {
            field: 'eventDesc',
            title: '事件分类描述',
            visible: true,
          },
          {
            field: 'enableFlag',
            title: '是否启用',
            visible: true,
          },
          {
            field: 'accountCondition',
            title: '取值逻辑',
            visible: true,
          },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.searchForm, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_AEEVENT_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        }
      },
      chooseClick(value) {
        if (value == 'add' || value == 'edit') {
          let [query, name] = [{}, 'editAeEvent'];
          if (value == 'edit') {
            if (this.multipleSelection.length != 1) {
              this.$message({
                showClose: true,
                message: '请选择一条数据进行操作',
                type: 'error',
              });
            }
            [query, name] = [
              {
                type: 'edit',
                id: this.multipleSelection[0].id,
              },
              'editAeEvent',
            ];
          }
          let path = {
            path: '/generalAccounting/' + name,
            name: name,
            meta: {
              keepAlive: true,
            },
            query: query,
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (value == 'del') {
          this.handleDel();
        }
      },
      // 删除/撤销弹框
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.$message({ showClose: true, type: 'error', message: '您还未选择任何数据!' });
        }
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            this.del(ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids) {
        this.$axios.post(API.DELETE_AEEVENT, ids).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 列表双击
      dblclickEvent(value) {
        let path = {
          path: '/generalAccounting/editAeEvent',
          name: 'editAeEvent',
          meta: {
            keepAlive: false,
          },
          query: {
            type: 'query',
            id: value.row.id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>

<style scoped></style>
